import script from "./UserAnswer.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAnswer.vue?vue&type=script&setup=true&lang=ts"

import "./UserAnswer.vue?vue&type=style&index=0&id=912775f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-912775f2"]])

export default __exports__